<template>
  <md-card v-if="empty_order !== ''">
    <div class="text-center">
      <h1>{{ empty_order }}</h1>
      <template v-if="empty_order !== local_page_keys.alert_you_do_not_have_access_rights_to_this_page">
        <h3> {{ local_page_keys.label_you_can_take_a_new_order }}</h3>

        <md-button class="md-success" v-if="newOrder !== null" @click="getNewOrder()">
          {{ local_page_keys.button_get_a_new_order }}
        </md-button>
        <md-button v-else disabled>{{ local_page_keys.button_no_orders_in_the_queue }}</md-button>
      </template>
    </div>
    <div class="uk-margin-auto uk-margin">
      <CountNewOrders :role="role" :local_page_keys="local_page_keys"/>
    </div>
  </md-card>
  <md-card v-else-if="order_status === 'done'">
    <div v-if="showTimer" class="text-center p-5">
      <h1 v-if="role !== 'retoucher'">{{ local_page_keys.label_you_have_accepted_the_order }}</h1>
      <h1 v-else>{{ local_page_keys.label_you_have_completed_the_order }}</h1>
      <h2>
        <span v-if="orderdays >= 1"> {{ orderdays ? orderdays : 0 }} {{ local_page_keys.label_timer_days }}</span>
        <span v-if="orderdays < 1 && hours >= 1"> {{ hours ? hours : 0 }} {{
            local_page_keys.label_timer_hours
          }} </span>
        <span v-else-if="orderdays >= 1"> {{ hours ? hours : 0 }} {{ local_page_keys.label_timer_hours }} </span>

        <span> {{ minutes ? minutes : 0 }} {{ local_page_keys.label_timer_minutes }} </span>
        <span> {{ seconds ? seconds : 0 }} {{ local_page_keys.label_timer_seconds }}</span>

        <span> {{ local_page_keys.button_back }} </span>
      </h2>
      <md-button class="md-success" v-if="newOrder !== null" @click="getNewOrder()">
        {{ local_page_keys.button_get_a_new_order }}
      </md-button>
      <md-button v-else disabled>{{ local_page_keys.button_no_orders_in_the_queue }}</md-button>
    </div>
    <div class="uk-margin-auto uk-margin">
      <CountNewOrders :role="role" :local_page_keys="local_page_keys"/>
    </div>
  </md-card>

</template>

<script>
import CountNewOrders from "@/pages/Dashboard/Components/CountNewOrders";
export default {
  name: "Downtime",
  props: {
    empty_order: {
      require: false,
      default: ''
    },
    order_status: {
      require: false,
      default: ''
    },
    downtime: {},
    role: {
      type: String,
      require: true,
    }
  },
  data: () => ({
    newOrder: null,
    orderdays: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    showTimer: false,
    interval: null,
    interval2: null,
    orderDateTime: null,
    local_page_keys: {},
    countneworders: null,
  }),
  components: {
    CountNewOrders,
  },
  methods: {
    async getPageLocalization() {
      let namePage = 'order-downtime';
      await this.$store.dispatch('localization/pageLocal', {page: namePage});
      this.local_page_keys = await this.$store.getters['localization/pageLocal'];
    },
    diffOrderMinutes(data) {
      let orderDate = this.orderDateTime !== null ? this.orderDateTime : Date.now();
      this.showTimer = (orderDate === this.orderDateTime ? true : false);
      let now = Date.now();
      let diff = now - orderDate;
      if (data === 'minutes') {
        return Math.floor((diff % 3.6e6) / 6e4);
      } else if (data === 'hours') {
        let hours = Math.floor(diff / 3.6e6);
        if (hours > 24) {
          let days = Math.floor(hours / 24);
          hours = hours - 24 * days;
        }
        return hours;
      } else if (data === 'seconds') {
        return Math.floor((diff % 60000) / 1000);
      } else if (data === 'days') {
        let hours = Math.floor(diff / 3.6e6);
        return Math.floor(hours / 24);
      }
    },
    async getNewOrder() {
      let date = this.getDateTime();
      let msg = this.local_page_keys.alert_are_you_sure_you_want_to_take_on_a_new_order;
      let formData = new FormData();
      formData.append('date', date);
      if (confirm(msg)) {
        this.$emit('is-loading', true);
        let data;
        if (this.role === 'test-retoucher') {
          let role = this.getRoleForTestRetoucher();
          await this.$store.dispatch("ordertest/getNewOrder", {role, formData});
          data = this.$store.getters["ordertest/getNewOrder"];
        } else {
          await this.$store.dispatch("order/getNewOrder", formData);
          data = await this.$store.getters['order/getNewOrder'];
        }
        if (data && data.newOrder === "success") {
          window.location.reload();
        } else if (Object.keys(data).includes('newOrder') && Object.keys(data).includes('start')) {
          this.$emit('is-loading', false);
          this.newOrder = data.newOrder;
        } else {
          this.errors = this.local_page_keys.alert_failed_get_new_order;
        }
      }
    },
    getRoleForTestRetoucher() {
      if (window.location.href.includes('pro_retoucher')) {
        return 'pro-retoucher';
      } else if (window.location.href.includes('senior_retoucher')) {
        return 'senior-retoucher';
      } else if (window.location.href.includes('for_retoucher')) {
        return 'retoucher';
      }
    },
    getDateTime() {
      let date = new Date();
      let month = ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1));
      let day = (date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate();
      let todayDate = date.getFullYear() + '-' + month + '-' + day;
      let hours = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours();
      let minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
      let time = hours + ':' + minutes + ':' + seconds;
      return todayDate + ' ' + time;
    },
    async fetchDowntime() {
      let data;
      if (this.role === 'test-retoucher') {
        let role = this.getRoleForTestRetoucher();
        await this.$store.dispatch('ordertest/downtime', role)
        data = await this.$store.getters['ordertest/downtime'];
      } else {
        await this.$store.dispatch('order/downtime')
        data = await this.$store.getters['order/downtime'];
      }
      this.newOrder = data.newOrder;
    },
  },
  mounted() {
    this.getPageLocalization();
    this.newOrder = this.downtime.newOrder;
    if (this.downtime.start !== null) {
      this.orderDateTime = Date.parse(this.downtime.start.date_time_start);
      this.interval = setInterval(() => {
        this.seconds = this.diffOrderMinutes('seconds');
        this.minutes = this.diffOrderMinutes('minutes');
        this.hours = this.diffOrderMinutes('hours');
        this.orderdays = this.diffOrderMinutes('days');
      }, 1000);
    }
    this.interval2 = setInterval(() => {
      this.fetchDowntime();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.interval2);
  }
}
</script>

<style>

</style>